import { checkIsApp } from '@vfit/consumer/data-access';
import { Button } from '@vfit/shared/atoms';
import { purify } from '@vfit/shared/themes';
import { IAddressManualConfig } from './addressManual.models';
import {
  AddressManualContainer,
  AddressManualInputContainer,
  AddressManualTitle,
  AddressManualDescription,
  ErrorMsg,
} from './addressManual.style';
import { checkIsValidCity, checkIsValidProvince } from './addressManual.utils';
import useAddressManual from './hooks/useAddressManual';
import InputV2 from '../InputV2/input';
import SelectV2 from '../SelectV2/select';

const AddressManual = ({
  cmsConfig,
  onSubmit,
  state,
  inputVarian,
  buttonVariant,
  handleTrackError,
}: IAddressManualConfig) => {
  const {
    addressCardLabel,
    errors,
    register,
    onSelectProvince,
    italianProvinces,
    calculatedItalianProvinces,
    italianMunicipalities,
    calculatedItalianMunicipalities,
    onSelectCity,
    displayStateOrProvinceValue,
    cityProvince,
    isProvinceSelected,
    handleSubmit,
    getApiErrorMessage,
    setCityProvince,
    isValid,
  } = useAddressManual({
    cmsConfig,
    onSubmit,
    state,
  });

  const [addressCardLabelDescription] = purify([addressCardLabel?.description]);

  return (
    <AddressManualContainer>
      {addressCardLabel?.title && (
        <AddressManualTitle>{addressCardLabel?.title}</AddressManualTitle>
      )}
      {addressCardLabel?.description && (
        <AddressManualDescription
          dangerouslySetInnerHTML={{ __html: addressCardLabelDescription || '' }}
        />
      )}
      <AddressManualInputContainer>
        <InputV2
          data-cs-mask=""
          variant={inputVarian}
          error={errors?.['street']?.message as string}
          label={addressCardLabel?.labels?.street}
          {...register('street')}
          onError={() => handleTrackError?.('street')}
        />
        <InputV2
          data-cs-mask=""
          error={errors?.['streetNumber']?.message as string}
          label={addressCardLabel?.labels?.streetNumber}
          {...register('streetNumber')}
          onError={() => handleTrackError?.('streetNumber')}
        />
        <SelectV2
          data-cs-mask=""
          variant={inputVarian}
          error={errors?.['displayStateOrProvince']?.message as string}
          items={calculatedItalianProvinces}
          label={addressCardLabel?.labels?.displayStateOrProvince}
          editable
          {...register('stateOrProvince', {
            onChange: (event: any) => {
              if (checkIsValidProvince(event?.target?.value, italianProvinces)) {
                onSelectProvince(event?.target?.value);
              }
            },
          })}
          onError={() => handleTrackError?.('stateOrProvince')}
        />
        <SelectV2
          data-cs-mask=""
          variant={inputVarian}
          disabled={!isProvinceSelected}
          error={errors?.['city']?.message as string}
          items={calculatedItalianMunicipalities}
          label={addressCardLabel?.labels?.city}
          editable
          {...register('city', {
            onChange: (event: any) => {
              if (checkIsValidCity(event?.target?.value, italianMunicipalities)) {
                onSelectCity(event?.target?.value);
                setCityProvince((event?.target?.value?.match(/\((.*?)\)/) || '')[1]);
              }
            },
          })}
          onError={() => handleTrackError?.('city')}
        />
        <InputV2
          data-cs-mask=""
          variant={inputVarian}
          error={errors?.['postalCode']?.message as string}
          label={addressCardLabel?.labels?.postalCode}
          {...register('postalCode')}
          onError={() => handleTrackError?.('postalCode')}
        />
      </AddressManualInputContainer>
      {!isValid && Object.keys(errors).length > 0 && <ErrorMsg>{getApiErrorMessage()}</ErrorMsg>}
      <div style={{ marginTop: 25 }}>
        <Button
          onClick={() => handleSubmit()}
          disabled={!isValid}
          variant={checkIsApp() ? 'mva:primary' : buttonVariant}
        >
          {addressCardLabel?.buttonLabel}
        </Button>
      </div>
    </AddressManualContainer>
  );
};

export default AddressManual;

